export default __webpack_public_path__ + "static/media/112t.071adc33.jpg";